import { render, staticRenderFns } from "./LinkOrder.vue?vue&type=template&id=42c41e5f&scoped=true"
import script from "./LinkOrder.vue?vue&type=script&lang=js"
export * from "./LinkOrder.vue?vue&type=script&lang=js"
import style0 from "./LinkOrder.vue?vue&type=style&index=0&id=42c41e5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c41e5f",
  null
  
)

export default component.exports